const Pagination = ({ data, setPage, page }: any) => {
  const links = Array.from({ length: data.totalPages }, (_, i) => i + 1);
  return (
    <div className="w-full flex justify-end py-4">
      <label
        className={`mb-1 border border-primary text-black px-4 py-2 rounded me-2 font-semibold   ${
          data.prev_page
            ? "hover:text-white cursor-pointer hover:bg-primary hover:opacity-[0.9] transition duration-500 "
            : "opacity-30"
        }`}
      >
        Anterior
        <button
          className="hidden"
          onClick={() => {
            if (data.prev_page) {
              setPage({
                ...page,
                page: data.prev_page,
              });
            }
          }}
        ></button>
      </label>
      {links.map((link, index) => {
        return (
          <label
            key={index}
            className={`mb-1 border border-primary text-black px-4 py-2 rounded me-2 font-semibold    ${
              data.page == link
                ? "text-white cursor-pointer bg-primary opacity-[0.9]"
                : "hover:text-white cursor-pointer hover:bg-primary hover:opacity-[0.9] transition duration-500"
            }`}
          >
            {link}
            <button
              className="hidden"
              onClick={() => {
                setPage({
                  ...page,
                  page: link,
                });
              }}
            ></button>
          </label>
        );
      })}
      <label
        className={`mb-1 border border-primary text-black px-4 py-2 rounded me-2 font-semibold   ${
          data.next_page
            ? "hover:text-white cursor-pointer hover:bg-primary hover:opacity-[0.9] transition duration-500"
            : "opacity-30"
        }`}
      >
        Siguiente
        <button
          className="hidden"
          onClick={() => {
            if (data.next_page) {
              setPage({
                ...page,
                page: data.next_page,
              });
            }
          }}
        ></button>
      </label>
    </div>
  );
};

export default Pagination;
